import React from 'react';

/**
 * El contenido del aviso que muestra la frase del pedido debajo del mensaje. Sirve a los dos
 * desenlaces del «Copiar pedido»: «Pedido copiado» (la frase no está escrita en la fila, y es la
 * única forma de ver QUÉ se copió, cliente incluido) y «No pudimos copiar» (para seleccionarla y
 * copiarla a mano). Lo comparten la pantalla «Prompts» y la banda «Usa tu IA»; `.agp-toast-copy` es
 * CSS global (`_agency-prompts.scss`), así que se ve igual en los dos marcos.
 */
export function askPhraseToastContent(message, phrase) {
    return (
        <div className="agp-toast-copy">
            <span>{message}</span>
            <span className="agp-toast-copy__phrase">{phrase}</span>
        </div>
    );
}
